import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppserviceService } from './appservice.service';
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReceiptsComponent } from './dashboard/receipts/receipts.component';
import { AbandonComponent } from './dashboard/abandon/abandon.component';
import { MoveComponent } from './dashboard/move/move.component';
import { BookkitComponent } from './dashboard/bookkit/bookkit.component';
import { StockinsertComponent } from './dashboard/stockinsert/stockinsert.component';
import { PartsusageComponent } from './dashboard/partsusage/partsusage.component';
import { TransactionsComponent } from './dashboard/transactions/transactions.component';
import { UserComponent } from './dashboard/user/user.component';

import { HomeComponent } from './dashboard/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from 'src/app/dashboard/material.module';
import { UserdialogComponent } from './common/userdialog/userdialog.component';

import {NgbModule,NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgbAlertConfig} from '@ng-bootstrap/ng-bootstrap';

import { OrderModule } from 'ngx-order-pipe';

@NgModule({
  declarations: [
    AppComponent,
    ReceiptsComponent,
    AbandonComponent,
    MoveComponent,
    BookkitComponent,
    HomeComponent,
    UserdialogComponent,
    StockinsertComponent,
    PartsusageComponent,
    TransactionsComponent,
    UserComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    OrderModule
  ],
  providers: [AppserviceService,NgbActiveModal,NgbAlertConfig,{provide : LocationStrategy , useClass: HashLocationStrategy}],
  entryComponents: [
    UserdialogComponent
  ],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
